import {
  borderRadius,
  borderWidth,
  breakpoints,
  colors,
  font,
  fontSize,
  fontWeight,
  gap,
  margin,
  padding,
  spacing,
} from "./tokens";

export const theme = {
  colors,
  fontFamily: {
    montserrat: [font.en, "sans-serif"],
    cario: [font.ar, "serif"],
  },
  fontWeight,
  fontSize,
  container: {
    center: true,
    screens: {
      lg: "1376px",
    },
  },
  screens: breakpoints,
  extend: {
    spacing,
    borderRadius,
    borderWidth,
    margin,
    padding,
    gap,
    transitionProperty: {
      height: "height",
      flex: "flex-grow",
    },
    boxShadow: {
      "sticky-footer": "0 -1px 4px 0px rgba(0, 0, 0, 0.2)",
      "profile-popover": "0px 0px 5px -2px rgba(0,0,0,0.75)",
    },
    flexGrow: {
      "2": "2",
      "3": "3",
    },
    keyframes: {
      "accordion-down": {
        from: { height: "0" },
        to: { height: "var(--radix-accordion-content-height)" },
      },
      "accordion-up": {
        from: { height: "var(--radix-accordion-content-height)" },
        to: { height: "0" },
      },
      progress: {
        "0%": { transform: "translateX(-100%)" },
        "100%": { transform: "translateX(100%)" },
      },
      "fade-in-up": {
        "0%": {
          opacity: "0",
          transform: "translateY(-40px)",
        },
        "100%": {
          opacity: "1",
          transform: "translateY(0)",
        },
      },
      marquee: {
        "0%": { transform: "translateX(0%)" },
        "100%": { transform: "translateX(-100%)" },
      },
      "move-strips": {
        "0%": { backgroundPosition: "100px 0" },
        "100%": { backgroundPosition: "0 0" },
      },
      ripple: {
        "0%": { transform: "scale(1.5)", opacity: "0.6" },
        "100%": { transform: "scale(3)", opacity: "0" },
      },
      "shimmer-wave": {
        "0%": {
          transform: "translateX(-100%)",
        },
        "50%": {
          opacity: "0.8",
        },
        "100%": {
          transform: "translateX(100%)",
        },
      },
    },
    animation: {
      "accordion-down": "accordion-down 0.2s ease-out",
      "accordion-up": "accordion-up 0.2s ease-out",
      "progress-linear": "progress 1.5s infinite linear",
      "fade-in-up": "fade-in-up 0.2s ease-in-out",
      marquee: "marquee 12s linear infinite",
      ripple: "ripple 1s ease-out infinite",
      strips: "move-strips 5s infinite linear",
      "shimmer-wave": "shimmer-wave 1s infinite linear",
    },
    backgroundImage: {
      "striped-gradient":
        "linear-gradient(45deg, #0E5AA7 25%, #6293C5 25%, #6293C5 50%, #0E5AA7 50%, #0E5AA7 75%, #6293C5 75%, #6293C5)",
      "shimmer-gradient":
        "linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.8) 80%, rgba(255, 255, 255, 0) 100%);",
    },
    backgroundColor: {
      "skeleton-loader": "#eaeaea",
    },
  },
};

export default theme;
